interface Args {
  questions: {
    question: string;
    answer: string;
  }[];
}

export default function faqStructuredData({ questions }: Args) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: { '@type': 'Answer', text: answer },
    })),
  };
}
